














import Component from "vue-class-component";
import { BaseRootPageComponent } from "@/components/BaseRootPageComponent";

@Component
export default class NotFound extends BaseRootPageComponent {
  created() {
    this.setTitle("Page Not Found");
  }
}
